import {
  Card,
  Dimmer,
  Header,
  Item,
  ItemContent,
  ItemDescription,
  ItemHeader,
  Loader
} from "semantic-ui-react"
import { setServiceRequestType } from "../../../v1/actions/user"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import store from "../../../shared_component/utils/configureStore"
import { routerPaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import Notifications from "../../../v1/components/Notifications"
import {
  gaJSON,
  serviceSelectedEvents,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"
import ReactSVG from "react-svg"
import { updateCart } from "../../../v1/actions/user"
import { serviceRequestTypes } from "../../constants"
import { getUpdatedCart } from "../../../v1/helpers/orderHelpers"
import { CA } from "../../../v1/constants/states"

const SelectServiceType = ({
  t,
  history,
  user,
  serviceRequestType,
  updateCart,
  setServiceRequestType,
  activeVehicle,
  cart
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false

  useEffect(() => {
    if (user.country === CA) {
      if (serviceRequestType !== serviceRequestTypes.WALK_IN) {
        handleServiceType(serviceRequestTypes.WALK_IN)
      }
      if (serviceRequestType === serviceRequestTypes.WALK_IN) {
        if (isOilChangeService) {
          history.replace(routerPaths.selectDate)
        } else {
          history.replace(routerPaths.selectService)
        }
      }
    } else if (serviceRequestType.length > 0) {
      handleServiceType(serviceRequestType)
    }
  }, [serviceRequestType])

  const handleServiceType = async (serviceType) => {
    setIsSubmitting(true)
    setServiceRequestType(serviceType)
    try {
      if (serviceType !== cart.cart_type) {
        await updateCart(null, activeVehicle.id, null, undefined, {}, serviceType)
      }
      trackFirebaseAnalytics({
        event: gaJSON.pivot_modal_interaction,
        params: {
          user_choice: "switch_to_scheduled"
        }
      })
      setIsSubmitting(false)
      if (serviceType === serviceRequestTypes.WALK_IN && user.country !== CA) {
        history.replace(routerPaths.selectDate)
      } else if (isOilChangeService) {
        if (user.country === CA) {
          history.replace(routerPaths.selectDate)
          return
        }
        history.replace(routerPaths.shopSelection)
      } else {
        history.replace(routerPaths.selectService)
      }
    } catch (e) {
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_vehicle_submit_error
      })
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: e.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      setIsSubmitting(false)
    }
  }

  return (
    <Card className="select-type-card" raised={true}>
      <Dimmer active={isSubmitting} inverted>
        <Loader />
      </Dimmer>
      <Header as="h3">{t("How would you like to get service?")}</Header>
      <Item onClick={() => handleServiceType(serviceRequestTypes.WALK_IN)}>
        <div className="select-type-info">
          <ReactSVG src="/images/calendar-icon.svg" className="service-type-icon" />
          <ItemContent>
            <ItemHeader>Walk-in</ItemHeader>
            <ItemDescription>
              Best if you need service soon. Flexible arrival time. (e.g., Valvoline, Jiffy Lube)
            </ItemDescription>
          </ItemContent>
        </div>
      </Item>

      <Item onClick={() => handleServiceType(serviceRequestTypes.SCHEDULE_SERVICE)}>
        <div className="select-type-info">
          <ReactSVG src="/images/bolt.svg" className="service-type-icon" />
          <ItemContent>
            <ItemHeader>Schedule service</ItemHeader>
            <ItemDescription>
              Best for planning ahead or complex repairs. Lock in a guaranteed time slot. (e.g.,
              Firestone, Goodyear)
            </ItemDescription>
          </ItemContent>
        </div>
      </Item>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let serviceRequestType = user.serviceRequestType || ""
  const activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  let cart
  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  }

  return {
    user: user,
    cart: cart || {},
    serviceRequestType: serviceRequestType,
    activeVehicle
  }
}

export default withRouter(
  connect(mapStateToProps, {
    setServiceRequestType,
    updateCart
  })(withTranslation("vehicleDetails")(SelectServiceType))
)
